import { clone } from '../../util/others/clone.js';

/** Creates orphan clone of an RgObject
 *  i.e. removes the parent of top level object
 **/
function cloneRgObject(obj) {
    return clone({ ...obj, parent: undefined });
}

export { cloneRgObject };
//# sourceMappingURL=clone-rg-object.js.map
